import Navbar from "@/components/unsf/Navbar"
import Footer from "@/components/unsf/Footer"
import Breadcrumb from "@/components/unsf/Breadcrumb"
import UnsfHead, { UnsfMeta } from "@/components/unsf/UnsfHead"
import type {
  UnsfNavbarProps,
  UnsfFooterProps,
} from "@/components/unsf/LegalLayout"
import type { CartData } from "@/components/unsf/Cart"

interface Section {
  title: string
  text: string
}

interface Props {
  meta: UnsfMeta
  title: string
  sections: Section[]
  navbar: UnsfNavbarProps
  footer: UnsfFooterProps
  csrf_token: string
  cart: CartData
}

export default function About({
  meta,
  title,
  sections,
  navbar,
  footer,
  csrf_token,
  cart,
}: Props) {
  return (
    <>
      <UnsfHead meta={meta} />

      <Navbar
        isHome={false}
        logoWhite={navbar.logo_white}
        logoBlack={navbar.logo_black}
        labels={navbar.labels}
        urls={navbar.urls}
        locale={{
          current: navbar.locale.current,
          other: navbar.locale.other,
          switchUrl: navbar.locale.switch_url,
        }}
        csrfToken={csrf_token}
        cart={cart}
      />

      <main className="pt-36 pb-24 max-w-3xl mx-auto px-6">
        <Breadcrumb
          items={[{ label: "UNSF", href: navbar.urls.root }, { label: title }]}
          className="mb-6"
        />
        <h1 className="text-4xl font-bold mb-10 font-unsf-title text-contrast">
          {title}
        </h1>
        {sections.map((section) => (
          <section key={section.title} className="mb-10">
            <h2 className="text-2xl font-bold mb-3 font-unsf-title text-contrast">
              {section.title}
            </h2>
            <p className="text-content leading-relaxed">{section.text}</p>
          </section>
        ))}
      </main>

      <Footer
        logoWhite={footer.logo_white}
        labels={footer.labels}
        urls={footer.urls}
      />
    </>
  )
}
